// Angular modules
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'; // NEw HTTP (Angular 4.3+)

// Plugins
import { AppRoutingModule } from "./app-routing.module"
import { ToastrModule } from 'ngx-toastr';

// Components
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { PageSearchComponent } from './page-search/page-search.component';
import { FamilyDetailsPublicComponent } from './family-details-public/family-details-public.component';
import { ModalLoginComponent } from './modal-login/modal-login.component';
import { modalContactCompanyComponent } from './modal-contact-companies/modal-contact-companies.component';
import { ModalAcceptanceComponent } from './modal-acceptance/modal-acceptance.component';
import { ModalInaccuraciesComponent } from './modal-inaccuracies/modal-inaccuracies.component';

// Services
import { UserService } from "./services/user.service"
import { MechanicsService } from "./services/mechanics.service"
import { UtilsService } from "./services/utils.service"
import { SearchService } from './services/search.service';

// Necessary for ToastrModule

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";


@NgModule({ declarations: [
        AppComponent,
        FamilyDetailsPublicComponent,
        HeaderComponent,
        LanguageSelectorComponent,
        ModalAcceptanceComponent,
        ModalInaccuraciesComponent,
        ModalLoginComponent,
        PageSearchComponent,
        modalContactCompanyComponent,
    ],
    bootstrap: [AppComponent], imports: [FormsModule,
        NgMultiSelectDropDownModule,
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 1500,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
            onActivateTick: true,
        })], providers: [
        UserService,
        MechanicsService,
        UtilsService,
        SearchService,
        provideHttpClient(withInterceptorsFromDi()),
        // Angular 21 defaults to ZONELESS change detection (NoopNgZone) unless this
        // is provided. The app relies on zone-based CD (zone.js is loaded and
        // NgZone.run() is used throughout), so socket/HTTP updates were not
        // triggering any view refresh without a manual click. Restore it.
        provideZoneChangeDetection(),
    ] })
export class AppModule { }
